import { Button, FormFeedback, PasswordField } from '@sparemin/blockhead';
import React from 'react';
import AuthSpacer from '../AuthSpacer';
import useResetPasswordForm, {
  UseResetPasswordFormConfig,
} from './useResetPasswordForm';

export interface ResetPasswordFormProps
  extends Pick<
    UseResetPasswordFormConfig,
    'onSubmit' | 'onSuccess' | 'resetPasswordToken'
  > {}

/**
 * A form that handles resetting a user's password
 */
export const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  onSubmit,
  onSuccess,
  resetPasswordToken,
}) => {
  const {
    hasInputError,
    isLoading,
    onSubmit: handleSubmit,
    register,
    formState: { errors },
    validationState,
  } = useResetPasswordForm({ onSubmit, onSuccess, resetPasswordToken });

  return (
    <AuthSpacer as="form" onSubmit={handleSubmit}>
      <PasswordField
        aria-label="new password field"
        autoComplete="new-password"
        errorMessage={errors.password?.message}
        fluid
        isDisabled={isLoading}
        placeholder="New password"
        validationState={validationState.password}
        {...register('password')}
      />
      <PasswordField
        aria-label="confirm password field"
        errorMessage={errors.confirmPassword?.message}
        fluid
        isDisabled={isLoading}
        placeholder="Confirm new password"
        validationState={validationState.confirmPassword}
        {...register('confirmPassword')}
      />
      {errors.unregisteredError && (
        <FormFeedback>{errors.unregisteredError.message}</FormFeedback>
      )}
      <Button isDisabled={hasInputError || isLoading} fluid type="submit">
        submit
      </Button>
    </AuthSpacer>
  );
};

export default ResetPasswordForm;
